import React from "react";
import { useUser } from "reactfire";
import { classNames } from "utils/utils";
import SkeletonLoader from "components/skeletonLoader";
import { useLeague } from "context/leagueContext";
import { useRound } from "context/roundContext";
import { Md2Information } from "react-icons-ng/md2";
import LeaderboardInfo from "components/leaderboardInfo";
import { useTranslation } from "react-i18next";

const PayoutList = ({ list, isLoading, settled, payout, hasWinnings }) => {
  const { status, data: user } = useUser();
  const {
    state: { leagueUserData, leagueInfo },
  } = useLeague();

  const {
    state: { roundEvents, userRoundData, currentRound },
  } = useRound();
  const { t } = useTranslation();

  let topScore = null;

  for (const key in list) {
    if (list.hasOwnProperty(key) && list[key].count > 0) {
      topScore = key;
    }
  }

  const { highestID, secondHighestID, thirdHighestID } = getHighestScores(list);

  let minCorrect = leagueInfo?.minCorrectRule;

  let roundArray = Array.from(
    { length: roundEvents.length + 1 },
    (_, i) => i
  ).map((item) => {
    return { id: item, value: "0" };
  });

  const shouldDisplayUserInList =
    !leagueUserData?.gameOver ||
    leagueUserData?.passedRounds?.some((el) => el === currentRound?.id) ||
    leagueUserData?.exitRound == currentRound?.id;

  const fallBackUserList = [...roundArray]?.reverse().map((item, id) => {
    let remainingUsers = leagueInfo?.userCount;
    const leaderboardCount =
      item.id == 0 ? parseInt(remainingUsers) : parseInt(item.value);
    if (leagueInfo?.eliminatedCount)
      remainingUsers -= leagueInfo?.eliminatedCount;
    return (
      <div
        className={classNames(
          parseInt(item.id) < parseInt(minCorrect)
            ? "text-red-500 bg-[#DE564A]/10 "
            : "",
          item.id == 0
            ? "border-b-2 rounded-b-md border-white "
            : "text-gray-300",
          " flex justify-between px-2 py-1 border-x-2 border-white"
        )}
        key={item.id}
      >
        <span className="flex justify-start w-20 shrink-0">
          <div className="flex py-1 rounded-md justify-center items-center text-center px-2 w-8 font-medium whitespace-nowrap bg-gray-200 text-black shrink-0">
            {item.id}
          </div>
          {userRoundData?.correct == parseInt(item.id) &&
            (shouldDisplayUserInList || !settled) && (
              <div className="flex items-center">
                <img
                  src={user?.photoURL}
                  className="rounded-full w-8 h-8 ml-2 shrink-0"
                  alt=""
                />
                <span className="pl-2 text-black">
                  {t("tournament.leaderboard.you")}
                </span>
              </div>
            )}
        </span>

        <div className="flex justify-center items-center">
          <span className="font-bold">
            {item.id == 0 ? remainingUsers : item.value}
          </span>
          <span className="font-light pl-2">
            {/*             {t("tournament.leaderboard.player", {
              count: leaderboardCount,
            })} */}
          </span>
        </div>
        {hasWinnings &&
          (leagueInfo?.scoreRule == 8 || item.id >= minCorrect) && (
            <div className="flex justify-center items-center">
              <span className="flex justify-center w-20">
                <div className="flex bg-gray-200 text-white  py-1 rounded-md justify-center items-center text-center px-2 w-full font-medium whitespace-nowrap">
                  {item.id == 0
                    ? "-"
                    : leagueInfo?.scoreRule == 6
                    ? item.id >= minCorrect
                      ? Math.pow(2, item.id) + "p"
                      : "-"
                    : "-"}
                </div>
              </span>
            </div>
          )}

        {item.id < minCorrect && hasWinnings && (
          <div className="flex w-20"></div>
        )}
      </div>
    );
  });

  const userList =
    list &&
    Object.keys(list)
      .reverse()
      .map((key) => {
        //let findScore = getValueById(list, item.id);

        let prize = list[key].prize;
        let score = list[key].count;

        return (
          <div
            className={classNames(
              userRoundData?.correct === parseInt(key) ? "" : "",
              parseInt(key) > parseInt(topScore) ? "text-gray-300" : "",
              parseInt(key) < parseInt(minCorrect)
                ? "text-red-500 bg-[#DE564A]/10 "
                : "",
              parseInt(key) == parseInt(minCorrect)
                ? "" //"border-b border-red-500 pb-2"
                : "",

              parseInt(key) == 0 ? "border-b-2 rounded-b-md border-white" : "",
              "flex justify-between py-1 px-2 border-x-2 border-white"
            )}
            key={key}
          >
            <span className="flex justify-start w-20 shrink-0">
              <div
                className={classNames(
                  parseInt(key) < parseInt(minCorrect)
                    ? "bg-red-500 text-white"
                    : userRoundData?.correct === parseInt(key)
                    ? "bg-black text-white animate-pulse "
                    : parseInt(key) <= parseInt(topScore)
                    ? "bg-gray-200 text-black"
                    : "",

                  "flex py-1 rounded-md justify-center items-center text-center px-2 w-8 font-medium whitespace-nowrap shrink-0"
                )}
              >
                {parseInt(key)}
              </div>
              {userRoundData?.correct == parseInt(key) &&
                (shouldDisplayUserInList || !settled) && (
                  <div className="flex items-center">
                    <img
                      src={user?.photoURL}
                      className="rounded-full w-8 h-8 ml-2 shrink-0"
                      alt=""
                    />
                    <span className="pl-2 text-black">
                      {t("tournament.leaderboard.you")}
                    </span>
                  </div>
                )}
            </span>

            <div className="flex justify-center items-center">
              <span className="font-bold">{score}</span>
              {/*               <span className="font-light pl-2">
                {t("tournament.leaderboard.player", {
                  count: score,
                })}
              </span> */}
            </div>
            {hasWinnings && (
              <div
                className={classNames(
                  user.uid == parseInt(key) ? "font-bold" : "",
                  "flex justify-center items-center  "
                )}
              >
                <span className="flex justify-center w-20">
                  {leagueInfo?.scoreRule == 8 && prize ? (
                    <div
                      className={classNames(
                        highestID == key
                          ? "bg-green-500 text-white"
                          : secondHighestID == key
                          ? "bg-green-300 text-black"
                          : thirdHighestID == key
                          ? "bg-green-200 text-black  "
                          : "",
                        "flex   py-1 rounded-md justify-center items-center text-center px-2 w-full font-medium whitespace-nowrap"
                      )}
                    >
                      {prize.toFixed(0) === 0 ? "-" : prize.toFixed(0) + "p"}
                    </div>
                  ) : (
                    parseInt(key) >= parseInt(minCorrect) && (
                      <div
                        className={classNames(
                          parseInt(userRoundData?.correct) == parseInt(key)
                            ? "bg-green-500 text-white "
                            : parseInt(key) <= parseInt(topScore)
                            ? "bg-gray-200 text-black"
                            : "bg-gray-200 ",
                          "flex text-white py-1 rounded-md justify-center items-center text-center px-2 w-full font-medium whitespace-nowrap"
                        )}
                      >
                        {prize.toFixed(0) === 0 ? "-" : prize.toFixed(0)}p
                      </div>
                    )
                  )}
                </span>
              </div>
            )}
          </div>
        );
      });

  return (
    <div className="flex w-full flex-col space-y-1">
      {payout ? (
        <LeaderboardInfo
          number={payout}
          symbol={"p"}
          title={t("tournament.leaderboard.pot")}
          subtitle={t("tournament.leaderboard.shared")}
          type={"success"}
        />
      ) : (
        <></>
      )}

      {minCorrect && !settled && (
        <LeaderboardInfo
          number={minCorrect}
          title={t("tournament.leaderboard.min_correct")}
          type={
            parseInt(userRoundData?.correct) < parseInt(minCorrect)
              ? "warning"
              : "success"
          }
        />
      )}

      <div className="flex w-full flex-col pt-4">
        <div className="flex justify-between pb-2 text-xs px-2">
          <span className="flex justify-start w-20 shrink-0 uppercase">
            {t("tournament.leaderboard.correct")}
          </span>

          <div className="flex justify-center items-center uppercase">
            {t("tournament.leaderboard.players")}
          </div>
          {hasWinnings && (
            <div className="flex justify-center items-center  uppercase">
              <span className="flex justify-center w-20">
                {t("tournament.leaderboard.prize")}
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col">
          {isLoading ? (
            <SkeletonLoader type={"userTopList"} amount={3} />
          ) : !list ? (
            fallBackUserList
          ) : (
            userList
          )}
        </div>
      </div>
    </div>
  );
};

export default PayoutList;

function getHighestScores(list) {
  let highestPrize = -Infinity;
  let secondHighestPrize = -Infinity;
  let thirdHighestPrize = -Infinity;
  let highestID = null;
  let secondHighestID = null;
  let thirdHighestID = null;

  list &&
    Object.keys(list).forEach((id) => {
      const prize = list[id].prize;

      if (prize > highestPrize) {
        thirdHighestPrize = secondHighestPrize;
        thirdHighestID = secondHighestID;
        secondHighestPrize = highestPrize;
        secondHighestID = highestID;
        highestPrize = prize;
        highestID = id;
      } else if (prize > secondHighestPrize) {
        thirdHighestPrize = secondHighestPrize;
        thirdHighestID = secondHighestID;
        secondHighestPrize = prize;
        secondHighestID = id;
      } else if (prize > thirdHighestPrize) {
        thirdHighestPrize = prize;
        thirdHighestID = id;
      }
    });

  return { highestID, secondHighestID, thirdHighestID };
}
